import { GET } from "../../utils/constants/verbs";
import { put, takeLatest } from "redux-saga/effects";
import requestAPI from "../../helpers/requestHelpers";
import { Types } from "../ducks/coutries";
import urls from "../../utils/constants/urlsAPI";
function* requestCoutries() {
  try {
    const { countries } = yield requestAPI({
      verb: GET,
      endPoint: urls.getAllCountries
    });
    const parsedCoutries = countries.map(country => {
      return {
        id: country.id,
        name: country.name,
        isBrazil: country.is_brasil
      };
    });
    yield put({
      type: Types.COUNTRIES_REQUEST_SUCCESS,
      countries: parsedCoutries
    });
  } catch (e) {
    yield put({
      type: Types.COUNTRIES_REQUEST_FAIL,
      error: e
    });
  }
}

export function* watcherSaga() {
  yield takeLatest(Types.COUNTRIES_REQUEST, requestCoutries);
}
